import { render, staticRenderFns } from "./AuthAction.vue?vue&type=template&id=f99e28ea"
import script from "./AuthAction.vue?vue&type=script&lang=ts"
export * from "./AuthAction.vue?vue&type=script&lang=ts"
import style0 from "./AuthAction.vue?vue&type=style&index=0&id=f99e28ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports